<template>
  <div class="sidebar">
    <div class="sidebar-section">
      <div class="sidebar-top">
        <h3>Tags</h3>
      </div>

      <ul class="list">
        <li v-for="tag in props.tags" :key="tag.id">
          <NuxtLink :to="`/learn/blogs?tag=${tag.id}`">{{ tag.name }} ({{ tag.post_count }})</NuxtLink>
        </li>
      </ul>

      <NuxtLink to="/learn/blogs/" class="mt-4 button w-full reset-tags">
        Reset Tags
      </NuxtLink>
    </div>

    <div class="sidebar-section">
      <div class="sidebar-top">
        <h3>Share our Blog</h3>
      </div>
      
      <div class="sharethis-inline-share-buttons"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { ref, onBeforeMount } from 'vue';
// import { useNuxtApp, useHead } from '#app';

// Props
const props = defineProps({
  tags: Array<Object>
});

// we need head for sidebar?
// const { $metadata } = useNuxtApp();

// onBeforeMount(async () => {
//   useHead($metadata.createHeadObject());
// });

onMounted(() => {
  const st = window.__sharethis__;
  if (!st) {
    // console.log('loading sharethis');
    const script = document.createElement('script');
    script.src = 'https://platform-api.sharethis.com/js/sharethis.js#property=610abafcc02a980019717e3d>&product=inline-share-buttons';
    document.body.appendChild(script);
  } else if (typeof st.initialize === 'function') {
    st.href = window.location.href;
    st.initialize();
  }
});
</script>


<style scoped>
h1 {
  font-size: 26px;
  color: #00810e;
}

h2 {
  font-size: 26px;
  color: #517185;
  line-height: 32px;
  font-weight: 600;
  font-family: Poppins;
}

p,
li {
  font-size: 14px;
}

p {
  color: #517185;
  margin: 0.25rem 0 1rem;
}

ul {
  margin: 0.25rem 0 1rem 20px;
  list-style-type: disc;
}

li {
  color: #517185;
  margin: 5px 0;
}

a {
  color: #00810e;
}

.sidebar {
  width: 380px;
}

.sidebar-section {
  margin: 2.5rem 0;
}

.sidebar-form {
  background: #f7f7f7;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  width: 380px;
  padding-bottom: 20px;
}

.sidebar-top {
  background: #517185;
  height: 36px;
  position: relative;
  margin-bottom: 10px;
}

.sidebar-top h3 {
  color: #fff;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 36px;
  margin: 0 0 0 10px;
}

.response {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #00810e;
  /* Ask The Expert! */
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.list li {
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #d8d8d8;
  font-weight: bold;
  font-size: 14px;
  line-height: 36px;
}

.list li a {
  color: #00810e;
}

input[type="text"],
input[type="number"],
input[type="email"],
select,
textarea {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
  color: #517185;
}

input[type="submit"] {
  color: white;
  font-weight: 800;
  background-color: #00810e;
  padding: 12px 20px;
  border: none;
  cursor: pointer;
  border-radius: 50px;
}

button {
  width: 300px;
  height: 40px;
  background: #00810e;
  border-radius: 100px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
}

.reset-tags {
  background: #00810e;
  border-radius: 100px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
}

::placeholder {
  color: #517185;
}
</style>
